module.exports = __webpack_public_path__ + "media/images/katniss-sm-0133a32a20d0c28629f6c5af432efbb5.jpg";